import styled from 'styled-components';

import Container from '../container';

export const Wrapper = styled.div`
  max-width: 100%;
`;

export const InnerWrapper = styled(Container)`
  margin: -2px;
  padding: 2px;
  overflow-x: auto;
`;
